import { privStatePicked, privSponsorKey, privMemberId } from "../../utils";

export const sendTag = (gtmId, dataLayer) => {
  if (!gtmId) return;
  const payload = {
    event: dataLayer.event_name,
    eventProps: { dataLayer },
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const buildSet = (keys, obj = {}) => {
  keys.map((item) => (obj[item] = null));
  return obj;
};

const userProperties = () => {
  const set = buildSet([
    "pwa_ally",
    "click_id",
    "user_id",
    "session_id",
    "hash_id",
    "device_type",
    "timestamp",
    "device_id",
    "source",
    "medium",
    "campaign",
    "region",
    "zona",
    "plaza",
    "state",
    "city",
    "country",
    "age",
    "preferences",
    "user_source",
    "sex",
    "birthday_date",
    // "operation_sistem",
    "operation_system",
    "platform",
    "carrier",
    "loyalty_id",
  ]);
  const { platform, isMobile, userAgent } = getDeviceAndPlatform();
  set.pwa_ally = "oxxo_premia";
  set.device_type = isMobile ? "mobile" : "desktop";
  set.timestamp = Date.now();
  const str1 = localStorage.getItem(privStatePicked);
  set.state = str1 ? JSON.parse(str1).label : null;
  set.country = "Mexico";
  const str2 = localStorage.getItem(privSponsorKey);
  set.user_source = null;
  if (str2 === "spin-authorization") set.user_source = "spin by oxxo";
  else if (str2 === "token") set.user_source = "mioxxo";
  set.sex = "na";
  set.operation_system = `${platform} - ${userAgent}`;
  set.platform = platform;
  set.loyalty_id = localStorage.getItem(privMemberId);
  return set;
};

const getDeviceAndPlatform = (platform = "other", isMobile = false) => {
  const ua = navigator.userAgent;
  if (ua.match(/Windows/i)) {
    platform = "Windows";
  } else if (ua.match(/Android/i)) {
    platform = "Android";
    isMobile = true;
  } else if (ua.match(/iPhone/i) || ua.match(/iPad/i) || ua.match(/iPod/i)) {
    platform = "MacOs";
    isMobile = true;
  } else if (
    ua.match(/webOS/i) ||
    ua.match(/BlackBerry/i) ||
    ua.match(/Windows Phone/i)
  ) {
    isMobile = true;
  }
  return { platform, isMobile, userAgent: ua };
};

// Onboarding
export const event_properties_100_04 = () => ({
  event_name: "premia_pwa_onboarding_select_state_view",
  ...userProperties(),
});
export const event_properties_100_05 = () => ({
  event_name: "premia_pwa_onboarding_select_state_click",
  ...userProperties(),
});
export const event_properties_100_06 = () => ({
  event_name: "premia_pwa_onboarding_terms_view",
  ...userProperties(),
});
export const event_properties_100_07 = () => ({
  event_name: "premia_pwa_onboarding_terms_click",
  ...userProperties(),
});

// Dashboard
export const event_properties_101_01 = () => ({
  event_name: "premia_pwa_home_view",
  ...userProperties(),
});
export const event_properties_101_02 = () => ({
  event_name: "premia_pwa_home_transactions_click",
  ...userProperties(),
});
export const event_properties_101_03 = () => ({
  event_name: "premia_pwa_home_banner_punch_card_click",
  ...userProperties(),
  ...buildSet(["punch_card_id", "punch_card_progress", "banner_index"]),
});
export const event_properties_101_04 = () => ({
  event_name: "premia_pwa_home_banner_rewards_click",
  ...userProperties(),
  ...buildSet(["reward_id", "reward_progress", "banner_index"]),
});
export const event_properties_101_05 = () => ({
  event_name: "premia_pwa_home_banner_extra_points_click",
  ...userProperties(),
  ...buildSet(["extra_points_id", "banner_index"]),
});
export const event_properties_101_06 = () => ({
  event_name: "premia_pwa_home_banner_dashboard_click",
  ...userProperties(),
  ...buildSet(["promo_id"]),
});
export const event_properties_101_07 = () => ({
  event_name: "premia_pwa_home_banner_experience_click",
  ...userProperties(),
});

// Punch Cards
export const event_properties_102_01 = () => ({
  event_name: "premia_pwa_punch_card_home_view",
  ...userProperties(),
});
export const event_properties_102_02 = () => ({
  event_name: "premia_pwa_punch_card_product_click",
  ...userProperties(),
  ...buildSet(["punch_card_id", "punch_card_progress", "click_id"]),
});
export const event_properties_102_03 = () => ({
  event_name: "premia_pwa_punch_card_progress_view",
  ...userProperties(),
  ...buildSet(["punch_card_id", "punch_card_progress"]),
});
export const event_properties_102_04 = () => ({
  event_name: "premia_pwa_punch_card_terms_click",
  ...userProperties(),
  ...buildSet(["punch_card_id", "punch_card_progress"]),
});

// Extra Points
export const event_properties_103_01 = () => ({
  event_name: "premia_pwa_extra_points_home_view",
  ...userProperties(),
});
export const event_properties_103_02 = () => ({
  event_name: "premia_pwa_extra_points_product_click",
  ...userProperties(),
  ...buildSet(["extra_points_id", "partner", "click_id"]),
});
export const event_properties_103_03 = () => ({
  event_name: "premia_pwa_extra_points_product_view",
  ...userProperties(),
  ...buildSet(["extra_points_id", "partner"]),
});
export const event_properties_103_04 = () => ({
  event_name: "premia_pwa_extra_points_terms_click",
  ...userProperties(),
  ...buildSet(["extra_points_id", "partner"]),
});

// Rewards
export const event_properties_104_01 = () => ({
  event_name: "premia_pwa_rewards_home_view",
  ...userProperties(),
});
export const event_properties_104_02 = () => ({
  event_name: "premia_pwa_rewards_product_click",
  ...userProperties(),
  ...buildSet(["reward_id", "reward_progress", "click_id"]),
});
export const event_properties_104_03 = () => ({
  event_name: "premia_pwa_rewards_progress_view",
  ...userProperties(),
  ...buildSet(["reward_id", "reward_progress"]),
});
export const event_properties_104_04 = () => ({
  event_name: "premia_pwa_rewards_terms_click",
  ...userProperties(),
  ...buildSet(["reward_id", "reward_progress"]),
});

// Others
export const event_properties_105_01 = () => ({
  event_name: "premia_pwa_home_help_click",
  ...userProperties(),
});
export const event_properties_105_02 = () => ({
  event_name: "premia_pwa_home_terms_click",
  ...userProperties(),
});
export const event_properties_105_03 = () => ({
  event_name: "premia_pwa_home_privacy_policy_click",
  ...userProperties(),
});
export const event_properties_105_04 = () => ({
  event_name: "premia_pwa_home_privacy_policy_view",
  ...userProperties(),
});
export const event_properties_105_05 = () => ({
  event_name: "premia_pwa_home_terms_service_view",
  ...userProperties(),
});
export const event_properties_105_06 = () => ({
  // event_name: "premia_pwa_home_help_view",
  event_name: "premia_pwa_help_home_view",
  ...userProperties(),
});

// Experiencies
export const event_properties_106_01 = () => ({
  event_name: "premia_pwa_experience_home_view",
  ...userProperties(),
});
export const event_properties_106_02 = () => ({
  event_name: "premia_pwa_experience_filter_click",
  ...userProperties(),
});
export const event_properties_106_03 = () => ({
  event_name: "premia_pwa_experience_detail_click",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_04 = () => ({
  event_name: "premia_pwa_experience_progress_view",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_05 = () => ({
  event_name: "premia_pwa_experience_participate_click",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_06 = () => ({
  event_name: "premia_pwa_experience_product_click",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_07 = () => ({
  event_name: "premia_pwa_experience_product_view",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_08 = () => ({
  event_name: "premia_pwa_experience_terms_click",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_09 = () => ({
  event_name: "premia_pwa_experience_terms_view",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_10 = () => ({
  event_name: "premia_pwa_experience_privacy_click",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
export const event_properties_106_11 = () => ({
  event_name: "premia_pwa_experience_privacy_view",
  ...userProperties(),
  ...buildSet(["experience_id", "experience_progress"]),
});
